/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface City {

        /**
         * Codigo da cidade.
         */
        "code"?: string;

        /**
         * nome da cidade.
         */
        "name"?: string;
    }

}
